import {Box, Button} from '@mui/material';
import {Form, Formik, FormikProps} from 'formik';
import {AllowedUsersModel} from 'library/src/authentication/models/AllowedUsersModel';
import React from 'react';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import IntlMessages from 'shared/components/IntlMessages';
import useStyles from 'shared/components/layout/HeaderButton.style';
import weatherActions from '../actions/WeatherActions';
import {WeatherStationCredentials} from '../models/BaseWeatherStationSchema';
import {UserWeatherStationPayload} from '../models/UserWeatherStationPayload';
import {
  ConnectedStationType,
  WeatherStationResponse,
} from '../models/WeatherStationResponse';
import getWeatherCredentialsUtils from '../services/getWeatherStationInitialValue';
import SencropCredentialsForm from './SencropCredentialsForm';
import WeenatCredentialsForm from './WeenatCredentialsForm';

interface WeatherStationCredentialsFormProps {
  selectedProvider: WeatherStationResponse;
  selectedProducer: AllowedUsersModel;
}
const WeatherStationCredentialsForm: React.FC<WeatherStationCredentialsFormProps> =
  (props) => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const classes = useStyles();
    const {selectedProvider, selectedProducer} = props;

    const handleSubmit = (e) => {
      if (e) {
        const dataToSend = {
          uid: selectedProducer.uid,
          provider_id: selectedProvider.provider_id,
          credentials: e,
        } as UserWeatherStationPayload<WeatherStationCredentials>;
        dispatch(weatherActions.modifyUserWeatherStation(dataToSend));
      }
    };

    const {initialValue, validationSchema} = getWeatherCredentialsUtils(
      selectedProducer,
      selectedProvider.provider_type,
      intl,
    );

    const selectWeatherForm = (formikProps: FormikProps<any>) => {
      switch (selectedProvider.provider_type) {
        // case ConnectedStationType.MF:
        //   return (
        //     <MfCredentialsForm formikProps={formikProps} disable={false} />
        //   );
        case ConnectedStationType.SENCROP:
          return (
            <SencropCredentialsForm formikProps={formikProps} disable={false} />
          );
        case ConnectedStationType.WEENAT:
          return (
            <WeenatCredentialsForm formikProps={formikProps} disable={false} />
          );
        default:
          return null;
      }
    };

    return (
      <Formik
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize>
        {(formikProps) => (
          <Form>
            {selectWeatherForm(formikProps)}
            <Box
              flexDirection='row'
              alignItems='center'
              justifyContent='center'
              display='flex'>
              <Button
                variant='contained'
                color='primary'
                type='submit'
                className={classes.formUserButton}>
                <IntlMessages id='modifyUser.submitButton' />
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    );
  };

export default WeatherStationCredentialsForm;
